import { render } from "./ServerValidation.vue?vue&type=template&id=9699aa4e&scoped=true"
import script from "./ServerValidation.vue?vue&type=script&lang=js"
export * from "./ServerValidation.vue?vue&type=script&lang=js"

import "./ServerValidation.vue?vue&type=style&index=0&id=9699aa4e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9699aa4e"]])

export default __exports__